<template>
  <div class="l-upload-list">
    <div
      v-if="readonly && !fileList.length"
      class="l-upload-item"
    >
      <p class="no-image">暂无图片</p>
    </div>
    <template v-else>
      <div
        v-for="(item, index) in fileList"
        :key="index"
        class="l-upload-item"
      >
        <van-image
          :src="item"
          fit="cover"
          width="100%"
          height="100%"
          @click="handlePreview(index)"
        />
        <div
          v-if="!readonly"
          class="icon-del"
          @click="handleDelImage(index)"
        />
      </div>
    </template>
    <van-uploader
      v-if="canAdd"
      v-model="uploadList"
      :disabled="loading"
      :preview-image="false"
      :after-read="handleAfterRead"
      :max-size="10 * 1024 * 1024"
      @oversize="onOversize"
      class="l-upload-uploader"
    >
      <div
        v-if="loading"
        class="l-upload-loading"
      >
        上传中...
      </div>
      <div
        v-else
        class="l-upload-img"
      > <span class="upload-tips">上传凭证 <br>最多{{limit}}张</span></div>
    </van-uploader>
  </div>
</template>

<script>
import { Image as VanImage, ImagePreview, Uploader } from 'vant'
import { mapActions } from 'vuex'

export default {
  name: 'NdUpload',
  components: {
    VanImage,
    [Uploader.name]: Uploader
  },
  props: {
    // 传入的图片url列表，需要使用.sync
    images: {
      type: Array,
      default: () => []
    },
    // 只读模式
    readonly: {
      type: Boolean,
      default: false
    },
    // 上传个数限制
    limit: {
      type: Number,
      default: 5
    },
    fileType: {
      type: String,
      default: 'REFUND_EVIDENCE'
    }
  },
  inject: {
    vanForm: {
      type: Object,
      default: {}
    },
    vanField: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      uploadList: [],
      loading: false
    }
  },
  computed: {
    canAdd () {
      if (this.readonly) {
        return false
      }
      if (this.limit) {
        return this.limit > this.fileList.length
      }
      return true
    },
    fileList: {
      get () {
        return this.images
        // if (this.images && this.images.split(',').length) {
        //   return this.images.split(',')
        // } else {
        //   return []
        // }
      },
      set (val) {
        this.$emit('update:images', val)
        // 给van-uploader组件重新赋值
        this.uploadList = val
        // this.vanForm.validate(this.vanField.$props.name)
      }
    }
  },
  created () {
    this.uploadList = this.images
  },
  methods: {
    ...mapActions('authentication', ['uploadOSS']),
    // 选择文件完成事件
    async handleAfterRead (resp) {
      const base64File = await this.getImgBase64(resp.file)
      const params = {
        base64Str: base64File,
        fileType: this.fileType
      }
      this.loading = true
      const { success, data, msg } = await this.uploadOSS(params)
      this.loading = false
      if (success) {
        this.fileList.push(data)
      } else {
        this.$message(msg)
      }
    },
    // 图片转化为base64
    getImgBase64 (file) {
      return new Promise((resolve) => {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          let file = this.result.replace(/data:image\/(jpeg|png);base64,/, '')
          resolve(file)
        }
      })
    },
    // 上传大小提示
    onOversize () {
      this.$message('文件大小不能超过 10Mb')
    },
    // 删除图片
    handleDelImage (imageIndex) {
      this.fileList = this.fileList.filter(
        (item, index) => index !== imageIndex
      )
    },
    validate () {
      console.log('validate')
    },
    // 预览图片
    handlePreview (index) {
      ImagePreview({
        images: this.fileList,
        startPosition: index,
        closeable: true
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.l-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -23px;
  margin-right: -23px;
  .l-upload-item {
    width: 140px;
    height: 140px;
    margin-right: 22px;
    margin-bottom: 23px;
    border-radius: 10px;
    position: relative;
    .no-image {
      line-height: 140px;
      text-align: center;
    }
    .van-image {
      border-radius: 10px;
      overflow: hidden;
    }
    .icon-del {
      position: absolute;
      bottom: 0;
      right: -16px;
      width: 34px;
      height: 32px;
      background: url(./images/btn_delete@2x.png) center no-repeat;
      background-size: 100%;
      &::after {
        content: "";
        position: absolute;
        top: -10px;
        bottom: -10px;
        left: -10px;
        right: -10px;
      }
    }
  }
  .l-upload-uploader {
    width: 140px;
    height: 140px;
    margin-bottom: 23px;
    margin-right: 23px;
    .l-upload-loading {
      width: 140px;
      height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 10px;
    }
    .l-upload-img {
      width: 140px;
      height: 140px;
      background: url(./images/btn_add@2x.png) center no-repeat;
      background-size: 100%;
      position: relative;
      .upload-tips {
        position: absolute;
        width: 100%;
        top: 100px;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #cccccc;
        line-height: 28px;
      }
    }
  }
}
</style>
